/**
 * Copyright © Veeam Software Group GmbH.
 */

import React from 'react';
import { capitalize } from '@veeam-vspc/core';
import { colors as palette } from '@veeam-vspc/components';

import { BaseTrendChart } from '../../../BaseTrendChart';
import { TriggeredAlarmsService } from './services/triggered-alarms.service';
import { useLang } from 'views/providers/LangProvider/hooks';

export const TriggeredAlarms: React.FC = () => {
    const lang = useLang();

    const params = {
        colors: [palette.R800, palette.Y450],
        yTitle: lang.ALARMS,
    };

    return (
        <BaseTrendChart
            params={params}
            service={TriggeredAlarmsService}
            title={{ text: capitalize(lang.TRIGGERED_ALARMS) }}
        />
    );
};
